import { Table } from 'semantic-ui-react';

export default Table;
